export const Codes = () => {
  return <div>Generate Codes</div>;
};
